export const aplicableProgramFeatures = [
  { label: "Secondary/Supplementary Cards", value: 0 },
  { label: "Transaction Installments", value: 1 },
  { label: "Balance Transfer", value: 2 },
  { label: "Bill Payment", value: 3 },
  { label: "Rewards/Loyalty", value: 4 },
  { label: "PIN Purchase", value: 5 },
  { label: "Signature Purchase", value: 6 },
  { label: "Cash Advance (ATM Withdrawals)", value: 7 },
  { label: "International Transactions", value: 8 },
  { label: "Offline PIN Support", value: 9 },
  { label: "3D Secure E-Commerce Transactions", value: 10 },
  { label: "Other", value: 11 },
];
export const whoConductKyc = [
  "Managed by the i2c Inc. platform, based upon program settings",
  "Managed by Issuer/ISO/Sponsor Bank",
  "Other",
];
export const kybProcess = ["Yes", "No"];
export const kybResponsibilites = [
  "Managed by the i2c Inc. platform, based upon program settings",
  "Managed by Issuer/ISO/Sponsor Bank",
  "Other",
];
export const cardOrderPlacement = [
  {
    label: "Managed by Issuer/ISO/Sponsor Bank",
    value: "managed-by-sponsered-bank",
  },
  {
    label: "Program Managers/Partners will order corporate cards",
    value: "program-managers-will-corporate-cards",
  },
];
export const channel = [
  { label: "Card enrollment (C-Cart) web app portal", value: 0 },
  { label: "Card enrollment (C-Cart) mobile app", value: 1 },
  { label: "Bulk uploads through a batch file (CH-Auth File)", value: 2 },
  { label: "Partner portal (C-Partner)", value: 3 },
  { label: "API", value: 4 },
  { label: "Other", value: 5 },
];
export const cardActivationChannel = [
  { label: "IVR", value: 0 },
  { label: "Live Operator", value: 1 },
  { label: "Cardholder Website", value: 2 },
  { label: "Mobile App", value: 3 },
  { label: "API", value: 4 },
  { label: "Others", value: 5 },
];

export const pinManagmentOptions = [
  {
    label: "Cardholder will set the first card PIN upon activation",
    value: "card-holder-will-set-pin",
  },
  { label: "Default PIN", value: "default-pin" },
];

export const constumerPaymentOptions = [
  { label: "Check/Lockbox", value: 0 },
  { label: "ACH", value: 1 },
  { label: "Payments through API", value: 2 },
  { label: "Other", value: 3 },
];

export const lockboxServices = [
  { label: "N/A", value: "na" },
  { label: "i2c Inc.", value: "i2c" },
  { label: "Other", value: "other" },
];
export const pinManagememt = [
  { label: "Last 4 digits of card number", value: "last-4-card-number" },
  {
    label: "Last 4 digits of mobile phone number",
    value: "last-4-mobile-number",
  },
  { label: "Cardholder’s year of birth", value: "cardholder-birth-year" },
  { label: "Other", value: "other" },
];
export const pinMailer = ["Yes", "No"];
export const offlinePinSupport = ["Yes", "No"];
export const consumerPaymentOptions = [
  "Check/Lockbox",
  "ACH",
  "Payments through API",
  "Other",
];
export const lockboxService = ["N/A", "i2c Inc.", "Other"];
export const additionalPayment = [
  { label: "Overdue Amount", value: "overdue-amount" },
  { label: "Over Limit Amount", value: "over-limit-amount" },
  { label: "Over Limit Fee", value: "over-limit-fee" },
  { label: "VAT", value: "vat" },
  { label: "Insurance Premium", value: "insurance-premium" },
  { label: "Finance Charges", value: "finance-charges" },
  { label: "Transaction Fees", value: "transaction-fees" },
  { label: "Late Payment Fee", value: "late-payment-fee" },
  { label: "Cash Advance Balance", value: "cash-advance-balance" },
  { label: "Purchases Balance", value: "purchase-balance" },
  { label: "Installment", value: "installment" },
  { label: "Promotion Upfront Charges", value: "promotion-upfront-charges" },
];
export const paymentDistributionOpt = [
  {
    label: "Highest to Lowest APR",
    tooltip: "",
    value: "highest-to-lowest-apr",
  },
  {
    label: "Lowest to Highest APR",
    tooltip: "",
    value: "lowest-to-highest-apr",
  },
  {
    label: "Transaction Date",
    tooltip: "Will adjust the oldest transaction first.",
    value: "transaction-date",
  },
  {
    label: "Transaction Type",
    tooltip:
      "Will require the client to prioritize payment adjustment against cash advance, fee, and purchase transactions.",
    value: "transaction-type",
  },
];
export const distributionMinimumPay = [
  {
    label: "Highest to Lowest APR",
    tooltip: "",
    value: "highest-to-lowest-apr",
  },
  {
    label: "Lowest to Highest APR",
    tooltip: "",
    value: "lowest-to-highest-apr",
  },
  {
    label: "Manual Distribution",
    tooltip:
      "Note: For the manual distribution option, client will be required to provide the order in which the system will allocate payments against various components that make up the statement balance.",
    value: "manual-distribution",
  },
];
export const paymentDueDate = [
  {
    label: "Number of Days",
    value: "no-of-days",
    tooltip:
      "Due date to be set at ‘X’ number of days after the statement generation. If you select this option, specify the statement cycle duration below.",
  },
  {
    label: "Fixed Date",
    value: "fixed-date",
    tooltip:
      "Due date to be set on specified date(s) every month. If you select this option, specify the date(s) below.",
  },
];
export const cardAccountStatement = [
  {
    label: "Raw Data",
    value: 0,
    tooltip: "i2c Inc. will share raw data for account activity",
  },
  {
    label: "PDF",
    value: 1,
    tooltip:
      "i2c Inc. will generate card account statements based on the activity recorded in the system",
  },
];
export const statementGeneratedOn = [
  { label: "Start of month", value: "start-of-month" },
  { label: "5th", value: "5th" },
  { label: "10th", value: "10th" },
  { label: "15th", value: "15th" },
  { label: "20th", value: "20th" },
  { label: "25th", value: "25th" },
  { label: "End of month", value: "end-of0month" },
];
export const creditBreue = [
  { label: "Experian", value: 0 },
  { label: "Equifax", value: 1 },
  { label: "TransUnion", value: 2 },
  { label: "Other", value: 3 },
];
export const cardUsageRestriction = ["Yes", "No"];
export const cashAdvanceLimits = ["Yes", "No"];
export const cardholderNotification = [
  { label: "Send alerts to Cardholders", value: "send-alert-to-cardholder" },
  {
    label: "Send alerts data to Program Managers",
    value: "send-alert-to-program-manager",
  },
];
export const customerSupportChannels = [
  { label: "IVR", value: "ivr" },
  {
    label: "Call/Email Support",
    value: "call-email-support",
  },
];
export const customerSupportProvider = [
  { label: "i2c Inc.", value: "i2c" },
  {
    label: "Client/Third Party",
    value: "client-third-party",
  },
];
export const alertChannel = ["SMS", "Email", "Push"];
export const customeSupportChannel = ["IVR", "Call/Email Support"];
export const provideCustomerSupport = ["i2c Inc.", "Client/Third Party"];
